import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    heading: {
        fontSize: "1rem",
        fontWeight: 500,
        color: theme.colors.gray[9],
        margin: 0,
        lineHeight: "normal",
    },
}))
